import React from "react";
import firstImage from "../assets/images/Main-banner-image.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const firstPage = () => {
  return (
    <>
      <div className="container mx-auto flex flex-col items-center text-center lg:flex-row lg:justify-between px-2 py-8 lg:py-0 mt-[70px] sm:mt-[50px] lg:mt-[10px] mainbanner-class">
        <div className="flex flex-col items-center lg:flex-row lg:justify-center mt-2 lg:mt-0 first-img lg:mb-0 lg:order-1 order-2 -mb-10">
          <img
            src={firstImage}
            alt="Illustration"
            className="w-[350px] h-[280px] sm:w-[500px] sm:h-[466px] md:w-[575px] md:h-[554px] lg:-ml-[6%] custom-img"
          />
        </div>
        <div className="w-full sm:max-w-md lg:max-w-none lg:w-2/5 text-center lg:text-left lg:-mt-24 main-block mb-0 lg:mb-0 lg:order-2 order-1">
          <h2 className="text-base md:text-lg font-extrabold heading-text">
            <span className="font-extrabold text-[#12AD63] text-2xl md:text-3xl">
              NutriLens{" "}
            </span>
            <span className="font-extrabold text-[#484647] text-2xl md:text-3xl">
              AI.{" "}
            </span>
          </h2>
          <br />
          <p className="text-margin">
            <span className="text-lg md:text-xl mt-2 md:mt-4 max-w-md text-black mx-auto lg:mx-0 font-bold">
              Calorie Counter
            </span>
            <br />
            <span className="text-lg md:text-xl mt-2 md:mt-4 max-w-md text-black mx-auto lg:mx-0">
              Scan your food, log meals instantly, and track calories with
              AI-powered nutrition insights.
            </span>
          </p>

          <div className="flex mt-4 justify-center lg:justify-start items-center">
            <div className="inline-block mr-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.sstech.nutrilens"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlayStore}
                  alt="Google Play Store"
                  className="h-[60px] w-auto"
                />
              </a>
            </div>
            <div className="inline-block">
              <a
                href="https://apps.apple.com/in/app/nutrilens-ai-calorie-counter/id6776608256"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applerPlayStore}
                  alt="Apple App Store"
                  className="h-[60px] w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 581px) and (min-width: 388px) {
          .mainbanner-class {
            padding-left: 16px;
            padding-right: 16px;
          }

          .first-img img {
            width: 450px;
            height: 450px;
          }

          .main-block {
            margin-top: -16px;
          }

          .text-margin {
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default firstPage;
